var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83728 2.66475C10.0345 2.86445 10.0524 3.17695 9.89107 3.39716L9.83728 3.46025L5.39284 7.96025C5.1956 8.15995 4.88696 8.1781 4.66947 8.01471L4.60716 7.96025L0.162718 3.46025C-0.0542393 3.24058 -0.0542393 2.88442 0.162718 2.66475C0.359953 2.46505 0.668592 2.4469 0.886083 2.61029L0.948393 2.66475L5 6.76675L9.05161 2.66475C9.24884 2.46505 9.55748 2.4469 9.77497 2.61029L9.83728 2.66475Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.77310f9d62a995841197ff95d15222fb.svg";
export { ForwardRef as ReactComponent };